

<div class="table-responsive">
  <div class="card">
    <div class="card-body">

      <div class="row">
        <div class="col-md-12">
          <div class="button-items mt-3 mb-3" style="float: left;padding-left: 1%;">
            <h2>Import Data</h2>
          </div>

          <div class="button-items mt-3 mb-3" style="float: right;">
            <button class="btn btn-primary btn-sm" (click)="loadImportData(lastTableLazyLoadEvent)" pTooltip="Refresh table" appActionTooltip><i
            class="mdi mdi-reload"></i></button>
            <button class="btn btn-primary btn-sm" (click)="dt.clear()" pTooltip="Clear all filters" appActionTooltip>Clear <i class="mdi mdi-filter-remove"></i></button>
            <button class="btn btn-success btn-sm"  (click)="viewUploadDialog()" pTooltip="Upload data file (Organization / Task / User / Vendor)" appActionTooltip>Upload</button>
          </div>
        </div>
      </div>
      <p-table [lazy]="true" #dt [columns]="cols" (onLazyLoad)="loadImportData($event)" [value]="importdata" dataKey="id" styleClass="p-datatable-users" [rowHover]="true"
        [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
        responsiveLayout="scroll" [paginator]="true" [autoLayout]="true" [totalRecords]="totalRecords"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th pSortableColumn="id">
              <div>
                ID
                <p-sortIcon field="id"></p-sortIcon>
                <p-columnFilter [showOperator]="false" [showAddButton]="false"
                  [matchModeOptions]="matchModeOptionsNumber" type="numeric" field="id"
                display="menu"></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="name">
              <div>
                Name
                <p-sortIcon field="name"></p-sortIcon>
                <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                  [matchModeOptions]="matchModeOptions" type="text" field="name"
                display="menu"></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="type">
              <div>
                Type
                <p-sortIcon field="type"></p-sortIcon>
                <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                  [matchModeOptions]="matchModeOptions" type="text" field="type"
                display="menu"></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="createdBy">
              <div>
                Created By
                <p-sortIcon field="createdBy"></p-sortIcon>
                <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                  [matchModeOptions]="matchModeOptions" type="text" field="createdBy"
                display="menu"></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="status">
              <div>
                Status
                <p-sortIcon field="status"></p-sortIcon>
                <p-columnFilter [showOperator]="false" [showAddButton]="false"
                  [matchModeOptions]="matchModeOptions" matchMode="equals" field="status"
                  display="menu">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-dropdown [ngModel]="value" [options]="statusList"
                      (onChange)="filter($event.value)" placeholder="Any">
                      <ng-template let-option pTemplate="item">
                        <span
                        [class]="'customer-badge descriptionType-' + option.value">{{option.label}}</span>
                      </ng-template>
                    </p-dropdown>
                  </ng-template></p-columnFilter>
                </div>
              </th>

              <th pSortableColumn="processedOn">
                <div>
                  Processed On
                  <p-sortIcon field="processedOn"></p-sortIcon>
                  <p-columnFilter [showOperator]="false" [showAddButton]="false"
                    [matchModeOptions]="matchModeOptionsDate" type="date" field="processedOn"
                  display="menu"></p-columnFilter>
                </div>
              </th>

            </tr>

          </ng-template>
          <ng-template pTemplate="body" let-importdata let-columns="columns">

            <tr >
              @for (col of columns; track col) {
                <td>
                  @if (col.field=='status'&&importdata[col.field]=='FAILED') {
                    <p><a (click)="failclick(importdata)" pTooltip="View failure details" appActionTooltip>{{importdata[col.field]}}</a></p>
                  }
                  @if (col.field!='status' || importdata[col.field]!='FAILED') {
                    <p>{{importdata[col.field]}}</p>
                  }
                </td>
              }


            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td [style]="{color:'var(--al-danger)'}" [attr.colspan]="columns && columns.length">
                {{gridCustomMessage?gridCustomMessage:'No records found'}}
              </td>
            </tr>
          </ng-template>
        </p-table>

        <p-dialog (onHide)="closeDialog()" [(visible)]="uploadDialog" [style]="{width: '80%'}" [header]="title" [modal]="true" styleClass="p-fluid" [resizable]="false" [draggable]="false">
          <ng-template pTemplate="content">
            @if (uploadLoading) {
              <div class="loading-indicator">
                <app-loading-spinner></app-loading-spinner>
              </div>
            }
            <app-notification [errorMsg]="errorMsg"></app-notification>
            <form [formGroup]="uploadForm">
              <div class="row mb-2">
                <div class="col-xl-4">
                  <label class="form-label">Import Type</label><span style="color:var(--al-danger);">*</span>
                  <select class="form-select"  formControlName="type" (change)="selecttype($event.target.value)">
                    <option  value="" >Select</option>
                    <option  value="ORGANIZATION" selected>Organization</option>
                    <option  value="TASK" >Task</option>
                    <option  value="USER" >User</option>
                    <option  value="VENDOR" >Vendor</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <label class="form-label">Choose and upload File</label>
                <p-fileUpload  [files]="myfiles" customUpload="true" (uploadHandler)="onUpload($event)" accept=".iif">
                </p-fileUpload>
              </div>
            </form>

          </ng-template>

        </p-dialog>

        <p-dialog  [resizable]="false" [draggable]="false" (onHide)="closeDialog()"  [(visible)]="failedDialog" [style]="{width: '80%'}" [header]="title" [modal]="true" styleClass="p-fluid">
          <p-table [lazy]="true" #dt [columns]="failedcols" (onLazyLoad)="loadFailedData($event)" [value]="failedData" dataKey="id" styleClass="p-datatable-users" [rowHover]="true"
            [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
            responsiveLayout="scroll" [paginator]="true" [autoLayout]="true" [totalRecords]="totalFailedRecords"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th pSortableColumn="type">
                  <div>
                    Type
                    <p-sortIcon field="type"></p-sortIcon>
                    <p-columnFilter [showOperator]="false" [showAddButton]="false"
                      [matchModeOptions]="matchModeOptions" type="text" field="type"
                    display="menu"></p-columnFilter>
                  </div>
                </th>
                <th pSortableColumn="exceptionStackTrace">
                  <div>
                    Exception
                    <p-sortIcon field="exceptionStackTrace"></p-sortIcon>
                    <p-columnFilter [showOperator]="false" [showAddButton]="false"
                      [matchModeOptions]="matchModeOptions" type="text" field="exceptionStackTrace"
                    display="menu"></p-columnFilter>
                  </div>
                </th>
                <th pSortableColumn="json">
                  <div>
                    Json
                    <p-sortIcon field="json"></p-sortIcon>
                    <p-columnFilter [showOperator]="false" [showAddButton]="false"
                      [matchModeOptions]="matchModeOptions" type="text" field="json"
                    display="menu"></p-columnFilter>
                  </div>
                </th>
              </tr>

            </ng-template>
            <ng-template pTemplate="body" let-faileddata let-columns="columns">
              <tr >
                @for (col of columns; track col) {
                  <td class='cell'>
                    {{faileddata[col.field]}}
                  </td>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="4">
                  No records found
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-dialog>

